import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { SystemManagementState } from "Interfaces";

const initialState: SystemManagementState = {
	deviceName: "",
	paswordExpiryTerm: 1,
	systemId: ""
};

// #region Reducers

const setSystemManagementReducer = (state: SystemManagementState, action: PayloadAction<SystemManagementState>) => {
	if (!action.payload) {
		return;
	}

	return action.payload;
};

// #endregion

// #region Selectors

const getSystemManagementSettings = (state: SystemManagementState) => {
	return state;
};

// #endregion

const systemManagementSlice = createAppSlice({
	name: "systemManagement",
	initialState,
	reducers: {
		setSystemManagementAction: setSystemManagementReducer
	},
	selectors: {
		selectSystemManagementSettings: getSystemManagementSettings
	}
});

export default systemManagementSlice;

export const { setSystemManagementAction } = systemManagementSlice.actions;
export const { selectSystemManagementSettings } = systemManagementSlice.selectors;
